<template>
  <a-button :style="{marginLeft: '5px'}" @click="addGroup">
    <a-icon type="usergroup-add" /> Добавить список
  </a-button>
</template>



<script>
import {mapState} from "vuex";

export default {
  components: {
    mapState
  },
  data () {
    return {}
  },
  methods: {
    addGroup () {
      const onSuccess = (r) => {this.$store.commit('setCurrentGroup', r)}
      const onError = () => this.$message.error('Ошибка')
      const newName = `Список №${this.$store.state.allGroupsList.length+1}`

      this.$store.dispatch('createGroup', { name: newName })
        .then((r) => onSuccess)
        .catch(onError)
    }
  }
}
</script>
<style scoped lang="scss">

</style>